import { handleActions } from 'redux-actions';
import { apiModuleDefaultState, createApiActions } from './helpers';

export const actions = createApiActions('articleDetails');

const reducer = handleActions(
  {
    [actions.api.articleDetails.request]: () => ({
      isFetching: true,
      isError: false,
    }),
    [actions.api.articleDetails.response]: (_, { payload }) => ({
      isFetching: false,
      isError: false,
      data: payload,
    }),
    [actions.api.articleDetails.error]: (_, { payload }) => ({
      isFetching: false,
      isError: true,
      error: payload,
    }),
    [actions.api.articleDetails.setstate]: (state, {payload}) => ({
      ...state,
      ...payload,
    })
  },
  { ...apiModuleDefaultState, data: [], error: null }
);

export default reducer;